import { stringify } from 'query-string';

export async function postRequest(url = '', requestBody = {}, customHeaders = {}) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...customHeaders
      },
      body: JSON.stringify(requestBody)
    });
    const res = await response.json();
    return res;
  } catch (err) {
    /* eslint-disable no-console */
    console.log('Error while performing post with url ', url);
  }
}

export async function getRequest(url = '', requestParams = {}, customHeaders = {}) {
  try {
    const response = await fetch(`${url}?${stringify(requestParams)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...customHeaders
      }
    });
    const res = await response.json();
    return res;
  } catch (error) {
    /* eslint-disable no-console */
    console.log('Error while performing get with url ', url);
  }
}
